import PageHeader from '../PageHeader';

function Error404(): JSX.Element {
  return (
    <>
      <PageHeader title="404 Error" />
      <div className="w-page mt-8">
        <div className="w-page-content">
          <div className="w-error w-error--404 d-flex align-items-center" />
        </div>
      </div>
    </>
  );
}

export default Error404;
